import service from '../utils/request'
// 根据ID获取详情
export const getttsurl = params => {return service.get(`/api/common/getttsurl`, {params: params})};
// 图片上传
export const upfileimage = params => {
    return service.post(`/api/Common/UpfileImage`, params)
};
